import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { opacity: 0.5 }, /* @__PURE__ */ React.createElement("circle", { cx: 16, cy: 9.99951, r: 2, fill: "black" }), /* @__PURE__ */ React.createElement("circle", { cx: 16, cy: 15.9995, r: 2, fill: "black" }), /* @__PURE__ */ React.createElement("circle", { cx: 16, cy: 21.9995, r: 2, fill: "black" })));
const ForwardRef = forwardRef(SvgMenu);
export default ForwardRef;
